import { useTranslation } from 'react-i18next';
import BasePageComponent from '../../components/BasePageComponent';
import './Sharpening.css';

const Sharpening = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <BasePageComponent
      id="sharpening"
      title={t('sharpening.title')}
      description={t('sharpening.description')}
    >
      <div className="service-card">
        <h2 className="service-title">{t('sharpening.service.title')}</h2>
        <div className="service-flow">
          <div className="flow-item">
            <div className="flow-number">1</div>
            <p className="flow-text">{t('sharpening.service.flow.item1')}</p>
          </div>
          <div className="flow-item">
            <div className="flow-number">2</div>
            <p className="flow-text">{t('sharpening.service.flow.item2')}</p>
          </div>
          <div className="flow-item">
            <div className="flow-number">3</div>
            <p className="flow-text">{t('sharpening.service.flow.item3')}</p>
          </div>
          <div className="flow-item">
            <div className="flow-number">4</div>
            <p className="flow-text">{t('sharpening.service.flow.item4')}</p>
          </div>
        </div>
      </div>

      <div className="service-card">
        <h2 className="service-title">{t('sharpening.shipping.title')}</h2>
        <div className="shipping-flow">
          <div className="flow-item">
            <div className="flow-number">1</div>
            <p className="flow-text">{t('sharpening.shipping.flow.item1')}</p>
          </div>
          <div className="flow-item">
            <div className="flow-number">2</div>
            <p className="flow-text">{t('sharpening.shipping.flow.item2')}</p>
          </div>
          <div className="flow-item">
            <div className="flow-number">3</div>
            <p className="flow-text">{t('sharpening.shipping.flow.item3')}</p>
          </div>
          <div className="flow-item">
            <div className="flow-number">4</div>
            <p className="flow-text">{t('sharpening.shipping.flow.item4')}</p>
          </div>
        </div>
      </div>
      
      <div className="service-card">
        <h2 className="service-title">{t('sharpening.details.title')}</h2>
        <div className="service-details">
          <div className="detail-section">
            <h3 className="detail-title">{t('sharpening.details.time.title')}</h3>
            <p className="detail-text">{t('sharpening.details.time.text')}</p>
            <p className="detail-note">{t('sharpening.details.time.note')}</p>
          </div>
          <div className="detail-section">
            <h3 className="detail-title">{t('sharpening.details.price.title')}</h3>
            <p className="detail-price">{t('sharpening.details.price.text')}</p>
            <p className="post-price">{t('sharpening.details.price.note')}</p>
          </div>
        </div>
      </div>
      
      <div className="contact-buttons">
        <a
          href="https://liff.line.me/1645278921-kWRPP32q/?accountId=474vxczq"
          target="_blank"
          rel="noopener noreferrer"
          className="contact-button"
        >
          {t('contact.info.line.button')}
        </a>
        <a
          className="contact-button"
          href="tel:+81672210824"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('contact.info.phone.button')}
        </a>
      </div>
    </BasePageComponent>
  );
};

export default Sharpening; 